import React, { useState, useEffect } from "react";

const IncorrectPopup = ({ onNext, label }) => {

  const handleNextClick = () => {
    onNext();
  };

  return (
    <div className="flex flex-col items-center justify-center h-max">
      <div className="bg-white p-8 rounded-lg shadow-lg">
        <div className="mb-4 text-2xl">{label}</div>

        <button
          onClick={handleNextClick}
          className="border-b-4 w-[140px] border-red-700 bg-red-500 text-white py-2 px-4 rounded-lg transition-colors"
        >
          NEXT
        </button>
      </div>
    </div>
  );
};

export default IncorrectPopup;
